


















































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import DataPanel from '@/components/DataPanel.vue';
import 'swiper/dist/css/swiper.css';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { type } from '@/http/interface';
import BaseContainer from '@/components/BaseContainer.vue';
import { LoginApi } from '@/http';
import login from '@/vuex/modules/login';

@Component({
    components: {
        swiper,
        swiperSlide,
        DataPanel,
        BaseContainer,
        PageDescribe,
    },
})
export default class PermissonSetting extends Vue {
    // 企业-添加/编辑表单
    public authFormEdit: any = {
        name: '',
        key: '',
        childList: [],
    };
    public authFormAdd: any = {
        name: '',
        key: '',
        childList: [],
    };
    // 承运-添加/编辑表单
    public supForm: any = {
        name: '',
        key: '',
        childList: [],
    };
    public supFormEdit: any = {
        name: '',
        key: '',
        childList: [],
    };
    public content: string = '此模块为系统开发人员专用，可配置系统基本权限树';
    public title: string = '权限配置';
    public id = 1000;
    public loading: boolean = false;
    // 记录修改前的值
    public oldName = '';
    public oldKey = '';
    // 权限数据源
    public treeData: any = [];
    public supTreeData: any = [];
    // 保存的权限树
    public saveData: any = [];
    public saveSupData: any = [];
    // 当前编辑的节点数据
    public curTreeData: any = {
        name: '',
        key: '',
        childList: [],
    };
    public curTreeSupData: any = {
        name: '',
        key: '',
        childList: [],
    };
    // 标题
    public eTitle = '';
    public supTitle = '';
    // 弹框显隐
    public dialogFormAdd: boolean = false;
    public dialogFormEdit: boolean = false;
    public dialogSupFormAdd: boolean = false;
    public dialogSupFormEdit: boolean = false;
    // 验证规则
    public formRules = formRules;

    public defaultProp = {
        label: 'name',
        children: 'childList',
    };
    public defaultSupProp = {
        label: 'name',
        children: 'childList',
    };
    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    public dialogConfig1: any = {
        title: '',
        show: false,
    };

    confirmClose1() {
        this.dialogConfig1 = {
            title: '',
            show: false,
        };
    }

    public activeName: string = 'first';
    public isShow: boolean = true;
    public handleClick() {
        if (this.activeName == 'first') {
            this.isShow = true;
        } else {
            this.isShow = false;
        }
    }

    public $refs: {
        authFormAdd: HTMLFormElement;
        authFormEdit: HTMLFormElement;
        supForm: HTMLFormElement;
        supFormEdit: HTMLFormElement;
    };
    // 企业-swiper配置
    public swiperOption;
    // 承运-swiper配置
    public swiperSupOption;
    public created() {
        this.init();
        // 企业-swiper配置
        this.swiperOption = {
            freeMode: true,
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 10,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };
        // 承运-swiper配置
        this.swiperSupOption = {
            freeMode: true,
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 10,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };
    }
    public perId = '';
    public supId = '';
    public init() {
        //企业权限
        this.treeData = [];
        LoginApi.GetPermissionTree({ type: 1 }).then((res) => {
            this.perId = res.id;
            res.permissions.forEach((item, index) => {
                this.treeData.push({
                    key: item.key,
                    name: item.name,
                    childList: item.childList,
                });
            });
        });
        //承运商权限
        this.supTreeData = [];
        LoginApi.GetPermissionTree({ type: 2 }).then((res) => {
            this.supId = res.id;
            res.permissions.forEach((item, index) => {
                this.supTreeData.push({
                    key: item.key,
                    name: item.name,
                    childList: item.childList,
                });
            });
        });
    }
    //新增一级导航菜单
    // public addLevel() {
    //     this.eTitle = '新增权限';
    //     this.authFormAdd.name = '';
    //     this.authFormAdd.key = '';
    //     this.dialogFormAdd = true;
    // }
    //企业-当前菜单级别
    public currentLevel: Number = 0;
    public NodeAdd(node, data) {
        this.currentLevel = node.level;
        if (node.level === 3) {
            this.$message({
                message: '该项无法添加',
                type: 'info',
            });
        } else {
            this.eTitle = '新增权限';
            this.authFormAdd.name = '';
            this.authFormAdd.key = '';
            this.dialogFormAdd = true;
            // this.$refs.authFormAdd.resetFields();
            this.curTreeData = data;
        }
    }
    //承运-当前菜单级别
    public currentSupLevel: Number = 0;
    public supAdd(node, data) {
        this.currentSupLevel = node.level;
        if (node.level === 3) {
            this.$message({
                message: '该项无法添加',
                type: 'info',
            });
        } else {
            this.supTitle = '新增权限';
            this.supForm.name = '';
            this.supForm.key = '';
            // this.$refs.supForm.resetFields();
            this.dialogSupFormAdd = true;
            this.curTreeSupData = data;
        }
    }

    // 企业-编辑权限
    public NodeEdit(node, data) {
        this.eTitle = '编辑权限';
        this.dialogFormEdit = true;
        this.authFormEdit = data;
        this.oldName = data.name;
        this.oldKey = data.key;
    }
    // 承运-编辑权限
    public supEdit(node, data) {
        this.supTitle = '编辑权限';
        this.dialogSupFormEdit = true;
        this.supFormEdit = data;
        this.oldName = data.name;
        this.oldKey = data.key;
    }

    public nodeRow: any;
    public dataRow: any;
    public nodeRow1: any;
    public dataRow1: any;
    public srowTy: string = '';
    // 企业-删除权限
    public NodeDel(node, data) {
        if (node.level != 1) {
            this.nodeRow = node;
            this.dataRow = data;
            this.srowTy = 'a';
            this.dialogConfig = {
                title: '删除该权限',
                show: true,
            };
            // this.$confirm('是否删除该权限？')
            //     .then((e) => {
            //         const parent = node.parent;
            //         const children = parent.data.childList || parent.data;
            //         const index = children.findIndex((d) => d.name === data.name);
            //         children.splice(index, 1);
            //         LoginApi.EditPermissionTree({ id: this.perId, type: 1, permissions: this.treeData })
            //             .then((response) => {
            //                 this.$message({
            //                     type: 'success',
            //                     message: '删除成功！',
            //                 });
            //                 this.init();
            //             })
            //             .catch((error) => {});
            //     })
            //     .catch(() => {});
        } else {
            this.$message({
                type: 'info',
                message: '该项无法删除！',
            });
        }
    }
    // 承运-删除权限
    public supDel(node, data) {
        if (node.level != 1) {
            this.nodeRow1 = node;
            this.dataRow1 = data;
            this.srowTy = 'b';
            this.dialogConfig = {
                title: '删除该权限',
                show: true,
            };
            // this.$confirm('是否删除该权限？')
            //     .then((e) => {
            //         const parent = node.parent;
            //         const children = parent.data.childList || parent.data;
            //         const index = children.findIndex((d) => d.name === data.name);
            //         children.splice(index, 1);
            //         LoginApi.EditPermissionTree({ id: this.supId, type: 2, permissions: this.supTreeData })
            //             .then((response) => {
            //                 this.$message({
            //                     type: 'success',
            //                     message: '删除成功！',
            //                 });
            //                 this.init();
            //             })
            //             .catch((error) => {});
            //     })
            //     .catch(() => {});
        } else {
            this.$message({
                type: 'info',
                message: '该项无法删除！',
            });
        }
    }
    async confirmOk() {
        if (this.srowTy == 'a') {
            const parent = this.nodeRow.parent;
            const children = parent.data.childList || parent.data;
            const index = children.findIndex((d) => d.name === this.dataRow.name);
            children.splice(index, 1);
            LoginApi.EditPermissionTree({ id: this.perId, type: 1, permissions: this.treeData })
                .then((response) => {
                    this.$message({
                        type: 'success',
                        message: '删除成功！',
                    });
                    this.init();
                })
                .catch((error) => {});
        } else if (this.srowTy == 'b') {
            const parent = this.nodeRow1.parent;
            const children = parent.data.childList || parent.data;
            const index = children.findIndex((d) => d.name === this.dataRow1.name);
            children.splice(index, 1);
            LoginApi.EditPermissionTree({ id: this.supId, type: 2, permissions: this.supTreeData })
                .then((response) => {
                    this.$message({
                        type: 'success',
                        message: '删除成功！',
                    });
                    this.init();
                })
                .catch((error) => {});
        }
        this.dialogConfig = {
            show: false,
        };
    }

    // 企业-关闭编辑弹框
    public handleCloseEdit() {
        this.dialogFormEdit = false;
        this.authFormEdit.key = this.oldKey;
        this.authFormEdit.name = this.oldName;
    }
    // 承运-关闭编辑弹框
    public handleSupCloseEdit() {
        this.dialogSupFormEdit = false;
        this.supFormEdit.key = this.oldKey;
        this.supFormEdit.name = this.oldName;
    }

    // 企业-关闭新增弹框
    public handleClose() {
        this.$refs.authFormAdd.resetFields();
        this.dialogFormAdd = false;
    }
    // 承运-关闭新增弹框
    public handleSupClose() {
        this.$refs.supForm.resetFields();
        this.dialogSupFormAdd = false;
    }

    // 企业-新增保存
    public submitAdd() {
        this.loading = true;
        this.$refs.authFormAdd.validate((valid) => {
            if (valid) {
                this.srowTy = 'c';
                this.dialogConfig1 = {
                    title: '保存该数据',
                    show: true,
                };
                // this.$confirm('确定保存该数据吗？')
                //     .then((e) => {
                //         if (this.currentLevel == 1) {
                //             this.authFormAdd.key = this.authFormAdd.key + '2';
                //         } else if (this.currentLevel == 2) {
                //             this.authFormAdd.key = this.authFormAdd.key + '3';
                //         }
                //         const newChild = {
                //             name: this.authFormAdd.name,
                //             key: this.authFormAdd.key,
                //             childList: [],
                //         };

                //         if (!this.curTreeData.childList) {
                //             this.$set(this.curTreeData, 'childList', []);
                //         }
                //         this.curTreeData.childList.push(newChild);
                //         LoginApi.EditPermissionTree({ id: this.perId, PermissionType: 1, permissions: this.treeData })
                //             .then((res) => {
                //                 this.$message({
                //                     type: 'success',
                //                     message: '添加成功！',
                //                 });
                //                 this.loading = false;
                //                 this.dialogFormAdd = false;
                //             })
                //             .catch((error) => {
                //                 this.loading = false;
                //                 this.curTreeData.childList.pop();
                //             });
                //     })
                //     .catch((error) => {
                //         this.loading = false;
                //     });
            } else {
                this.loading = false;
            }
        });
    }
    // 承运-新增保存
    public submitSup() {
        this.loading = true;
        this.$refs.supForm.validate((valid) => {
            if (valid) {
                this.srowTy = 'd';
                this.dialogConfig1 = {
                    title: '保存该数据',
                    show: true,
                };
                // this.$confirm('确定保存该数据吗？')
                //     .then((e) => {
                //         if (this.currentSupLevel == 1) {
                //             this.supForm.key = this.supForm.key + '2';
                //         } else if (this.currentSupLevel == 2) {
                //             this.supForm.key = this.supForm.key + '3';
                //         }
                //         const newChild = {
                //             name: this.supForm.name,
                //             key: this.supForm.key,
                //             childList: [],
                //         };

                //         if (!this.curTreeSupData.childList) {
                //             this.$set(this.curTreeSupData, 'childList', []);
                //         }
                //         this.curTreeSupData.childList.push(newChild);
                //         LoginApi.EditPermissionTree({ id: this.supId, PermissionType: 1, permissions: this.supTreeData })
                //             .then((res) => {
                //                 this.$message({
                //                     type: 'success',
                //                     message: '添加成功！',
                //                 });
                //                 this.loading = false;
                //                 this.dialogSupFormAdd = false;
                //             })
                //             .catch((error) => {
                //                 this.loading = false;
                //                 this.curTreeSupData.childList.pop();
                //             });
                //     })
                //     .catch((error) => {
                //         this.loading = false;
                //     });
            } else {
                this.loading = false;
            }
        });
    }

    //企业-编辑保存
    public submitEdit() {
        this.loading = true;
        this.$refs.authFormEdit.validate((valid) => {
            if (valid) {
                this.srowTy = 'e';
                this.dialogConfig1 = {
                    title: '保存该数据',
                    show: true,
                };
                // this.$confirm('确定保存该数据吗？')
                //     .then((e) => {
                //         LoginApi.EditPermissionTree({ id: this.perId, type: 1, permissions: this.treeData })
                //             .then((response) => {
                //                 this.$message({
                //                     type: 'success',
                //                     message: '编辑成功',
                //                 });
                //                 this.dialogFormEdit = false;
                //                 this.loading = false;
                //             })
                //             .catch((error) => {
                //                 this.loading = false;
                //             });
                //     })
                //     .catch((error) => {
                //         this.loading = false;
                //     });
            } else {
                this.loading = false;
            }
        });
    }
    //企业-编辑保存
    public submitSupEdit() {
        this.loading = true;
        this.$refs.supFormEdit.validate((valid) => {
            if (valid) {
                this.srowTy = 'f';
                this.dialogConfig1 = {
                    title: '保存该数据',
                    show: true,
                };
                // this.$confirm('确定保存该数据吗？')
                //     .then((e) => {
                //         LoginApi.EditPermissionTree({ id: this.supId, type: 2, permissions: this.supTreeData })
                //             .then((response) => {
                //                 this.$message({
                //                     type: 'success',
                //                     message: '编辑成功',
                //                 });
                //                 this.dialogSupFormEdit = false;
                //                 this.loading = false;
                //             })
                //             .catch((error) => {
                //                 this.loading = false;
                //             });
                //     })
                //     .catch((error) => {
                //         this.loading = false;
                //     });
            } else {
                this.loading = false;
            }
        });
    }
    async confirmOk1() {
        if (this.srowTy == 'c') {
            if (this.currentLevel == 1) {
                this.authFormAdd.key = this.authFormAdd.key + '2';
            } else if (this.currentLevel == 2) {
                this.authFormAdd.key = this.authFormAdd.key + '3';
            }
            const newChild = {
                name: this.authFormAdd.name,
                key: this.authFormAdd.key,
                childList: [],
            };

            if (!this.curTreeData.childList) {
                this.$set(this.curTreeData, 'childList', []);
            }
            this.curTreeData.childList.push(newChild);
            this.$refs.authFormAdd.resetFields();
            LoginApi.EditPermissionTree({ id: this.perId, PermissionType: 1, permissions: this.treeData })
                .then((res) => {
                    this.$message({
                        type: 'success',
                        message: '添加成功！',
                    });
                    this.loading = false;
                    this.dialogFormAdd = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.curTreeData.childList.pop();
                });
        } else if (this.srowTy == 'd') {
            if (this.currentSupLevel == 1) {
                this.supForm.key = this.supForm.key + '2';
            } else if (this.currentSupLevel == 2) {
                this.supForm.key = this.supForm.key + '3';
            }
            const newChild = {
                name: this.supForm.name,
                key: this.supForm.key,
                childList: [],
            };

            if (!this.curTreeSupData.childList) {
                this.$set(this.curTreeSupData, 'childList', []);
            }
            this.curTreeSupData.childList.push(newChild);
            this.$refs.supForm.resetFields();
            LoginApi.EditPermissionTree({ id: this.supId, PermissionType: 1, permissions: this.supTreeData })
                .then((res) => {
                    this.$message({
                        type: 'success',
                        message: '添加成功！',
                    });
                    this.loading = false;
                    this.dialogSupFormAdd = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.curTreeSupData.childList.pop();
                });
        } else if (this.srowTy == 'e') {
            LoginApi.EditPermissionTree({ id: this.perId, type: 1, permissions: this.treeData })
                .then((response) => {
                    this.$message({
                        type: 'success',
                        message: '编辑成功',
                    });
                    this.dialogFormEdit = false;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        } else if (this.srowTy == 'f') {
            LoginApi.EditPermissionTree({ id: this.supId, type: 2, permissions: this.supTreeData })
                .then((response) => {
                    this.$message({
                        type: 'success',
                        message: '编辑成功',
                    });
                    this.dialogSupFormEdit = false;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        }
        this.dialogConfig1 = {
            show: false,
        };
    }
}
